import { useEffect } from 'react'
import { Spacer } from 'wiz-front-shared/components/Spacer'
import './QNADetail.css'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'
import { useAtomValue } from 'jotai'
import { qnaStore } from 'store/qnaStore'
import { QNA } from 'repository/types/QNA.types'
import { Header } from 'components/common/header/Header'

const formatDate = (dateString: string, t: (key: string, options?: any) => string): string => {
    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return t('qna.dateFormat', { year, month, day })
}

export const QNADetail = () => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()
    const qnaDetailState = useAtomValue(qnaStore.qnaDetail.stateAtom)

    const qnaNo = Number(searchParams.get('qnaNo'))
    const isInvalidQnaNo = Number.isNaN(qnaNo) || qnaNo <= 0
    const detailData = qnaDetailState?.data?.data?.item
        || qnaDetailState?.data?.item
        || qnaDetailState?.data?.data
        || qnaDetailState?.data
    const item: QNA.QnaItem | undefined = detailData
        ? {
            qnaNo: Number(detailData.qnaNo ?? detailData.qna_id ?? 0),
            title: detailData.title ?? '',
            content: detailData.content ?? '',
            answer: detailData.answer ?? null,
            status: detailData.status === 'ANSWERED' || detailData.status === 'answer' || detailData.status === 'COMPLETE' ? 'ANSWERED' : 'WAIT',
            categoryCode: detailData.categoryCode ?? 'ETC',
            regTime: detailData.regTime ?? detailData.regDt ?? detailData.reg_date ?? '',
            answerTime: detailData.answerTime ?? null,
        }
        : undefined

    useEffect(() => {
        if (!isInvalidQnaNo) {
            qnaStore.getQnaDetail(qnaNo)
        }
    }, [qnaNo, isInvalidQnaNo])

    if (isInvalidQnaNo) {
        return (
            <div className="qna-detail-wrapper">
                <Header title={t('qna.myQuestion')} isBack />
                <div className="qna-detail-empty">{t('qna.detail.invalid')}</div>
            </div>
        )
    }

    if (qnaDetailState.isPending) {
        return (
            <div className="qna-detail-wrapper">
                <Header title={t('qna.myQuestion')} isBack />
                <div className="qna-detail-empty">{t('qna.detail.loading')}</div>
            </div>
        )
    }

    if (qnaDetailState.isError || !item) {
        return (
            <div className="qna-detail-wrapper">
                <Header title={t('qna.myQuestion')} isBack />
                <div className="qna-detail-empty">{t('qna.detail.notFound')}</div>
            </div>
        )
    }

    return (
        <div className="qna-detail-wrapper">
            <Header title={t('qna.myQuestion')} isBack />

            <div className="qna-detail-content">
                <div className="qna-detail-question-card">

                    {/* 문의 제목 & 날짜*/}
                    <div className="qna-detail-question-header">
                        <span className="qna-detail-question-title">{item.title}</span>
                        <span className="qna-detail-date">{formatDate(item.regTime, t)}</span>
                    </div>
                    <Spacer height={4} />

                    {/* 카테고리 */}
                    <span className="qna-detail-category">{t(`qna.category.${item.categoryCode}`)}</span>
                    <Spacer height={14} />

                    {/* 문의 내용 */}
                    <p className="qna-detail-question-content">{item.content}</p>
                    
                </div>

                {item.answer && item.answerTime && (
                    <div className="qna-detail-answer-card">
                        <span className="qna-detail-answer-label">{t('qna.adminAnswer')}</span>
                        <Spacer height={10} />
                        <p className="qna-detail-answer-content">{item.answer}</p>
                        <Spacer height={24} />
                        <span className="qna-detail-answer-date">{t('qna.answerDate')}: {formatDate(item.answerTime, t)}</span>
                    </div>
                )}
            </div>
        </div>
    )
}
